var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "mt-4 mt-md-0" },
        [_c("page-header", { attrs: { page: _vm.page } })],
        1
      ),
      _c("MatchMedia", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ mobile }) {
              return [
                _c("filter-manager", {
                  ref: "filterComponent",
                  class: ["mb-4", { "filter-mobile": mobile }],
                  attrs: {
                    filters: _vm.filtersConfig,
                    "open-advanced": _vm.openAdvanced
                  },
                  on: { search: _vm.search },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "header_advanced",
                        fn: function() {
                          return [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col d-flex justify-content-end"
                                },
                                [
                                  _c("drop-down", {
                                    attrs: {
                                      items: _vm.handlerFilters,
                                      title:
                                        _vm.handlerFilters[
                                          _vm.handlerFilterSelected
                                        ].label,
                                      variant: "rounded-dark"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.filtersSelected,
                    callback: function($$v) {
                      _vm.filtersSelected = $$v
                    },
                    expression: "filtersSelected"
                  }
                })
              ]
            }
          }
        ])
      }),
      _vm.results.length > 0
        ? _c("separator", {
            staticClass: "my-3",
            attrs: { text: "Resultado de Referidos" }
          })
        : _vm._e(),
      _vm._l(_vm.results, function(result) {
        return _c("row", {
          key: result.admissionId,
          staticClass: "mb-3",
          attrs: {
            "allowed-go-to-record": _vm.allowedGoToStudentServiceRecord,
            "can-add-diagnosis": _vm.canAddDiagnosis,
            "can-add-result-summary": _vm.canAddResultSummary,
            centers: _vm.filters.centers,
            "current-academic-year-id": _vm.currentAcademicYearId,
            "future-academic-year": _vm.futureAcademicYear,
            "has-pilot-permission": _vm.hasPilotPermission(result),
            "medicaid-pilot-company-ids": _vm.medicaidPilotCompanyIds,
            value: result
          },
          on: {
            onShowVisitHistory: _vm.showHistory,
            refreshReferralGrid: _vm.refreshReferralGrid
          }
        })
      }),
      _c("visit-details-history-modal", {
        attrs: {
          "admission-id": _vm.visitHistory.admissionId,
          "is-open": _vm.visitHistory.show
        },
        on: {
          onClose: function($event) {
            _vm.visitHistory.show = false
          }
        }
      }),
      _vm.showPagination
        ? _c("pagination", {
            attrs: { data: _vm.pagination },
            on: { "pagination-go-page": _vm.pageChanged }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }